/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const PenIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M14.8556 7.28186C14.6724 7.09867 14.3976 7.09867 14.2144 7.28186L5.83344 15.617C5.65025 15.8002 5.65025 16.075 5.83344 16.2582C5.92503 16.3498 6.01663 16.3956 6.15402 16.3956C6.29141 16.3956 6.38301 16.3498 6.4746 16.2582L14.8098 7.92303C15.0388 7.73984 15.0388 7.41926 14.8556 7.28186Z"
        fill="white"
      />
      <path
        d="M1.4369 16.2582C1.3911 16.304 1.34531 16.3956 1.29951 16.4871L0.0171741 21.3875C-0.0286235 21.5249 0.0171741 21.7081 0.154567 21.8455C0.246162 21.9371 0.337758 21.9829 0.47515 21.9829C0.520948 21.9829 0.566746 21.9829 0.612543 21.9829L5.55869 20.7005C5.65028 20.7005 5.69608 20.6547 5.78768 20.5631L21.2215 5.12933C21.7253 4.57976 22 3.847 22 3.02264C22 2.24408 21.6337 1.46552 21.0841 0.915953C20.4887 0.320583 19.7102 0 18.8858 0C18.1072 0 17.4203 0.274786 16.8707 0.824357M4.87172 19.8762L1.11632 20.8837L2.07807 17.2199L3.3146 17.1283L3.22301 18.4106C3.22301 18.548 3.26881 18.6854 3.3604 18.777C3.452 18.8686 3.58939 18.9144 3.72678 18.9144L5.00912 18.777L4.87172 19.8762ZM5.87927 19.0976L5.97087 18.3191C5.97087 18.1817 5.92507 18.0443 5.83347 17.9527C5.74188 17.8611 5.60449 17.8153 5.46709 17.8153L4.18476 17.9527L4.32215 16.6703C4.32215 16.5329 4.27635 16.3956 4.18476 16.304C4.09316 16.2124 3.95577 16.1666 3.81838 16.1666L2.76503 16.2582L14.5808 4.39657L16.0921 5.90789L17.6035 7.41922L5.87927 19.0976ZM18.2446 6.77805L16.7333 5.26673L15.222 3.75541L15.8174 3.20583L17.3287 4.71716L18.84 6.22848L18.2446 6.77805ZM20.5345 4.48817L19.4812 5.54151L17.9698 4.03019L16.4585 2.51887L17.5119 1.46552C17.8783 1.09914 18.382 0.915953 18.8858 0.915953C19.4812 0.915953 19.9849 1.14494 20.4429 1.55712C20.8551 1.9693 21.0841 2.47307 21.0841 3.02264C21.0841 3.61801 20.9009 4.12179 20.5345 4.48817Z"
        fill="white"
      />
    </svg>
  )
}
